<template>
    <v-scale-transition>

        <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
            <template v-slot:activator="{ on }">

                <v-card flat tile color="transparent" max-width="500" v-show="visible" v-on="on">

                    <v-card flat tile :color="settings.surveyBoxColor"
                            :class="getFontClasses(settings.surveyBoxColor)"
                            :style="'border-left: 5px solid ' + settings.actionButtonColor">

                        <v-card-text>

                            <v-container class="pa-0">

                                <v-row dense>
                                    <v-col cols="12" align="left">

                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_text"
                                            @input="translationsChanged"
                                            hint="Project info text">
                                            <b :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ translations.project_info_text }}
                                            </b>
                                        </text-editor>

                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col cols="8" align="left">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_duration_text"
                                            @input="translationsChanged"
                                            hint="Project duration text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ translations.project_info_duration_text }}
                                            </div>
                                        </text-editor>
                                    </v-col>

                                    <v-col cols="4" align="right">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_duration"
                                            @input="translationsChanged"
                                            hint="Project duration text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ duration }}
                                            </div>
                                        </text-editor>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col cols="8" align="left">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_reward_text"
                                            @input="translationsChanged"
                                            hint="Project reward text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ translations.project_info_reward_text }}
                                            </div>
                                        </text-editor>
                                    </v-col>

                                    <v-col cols="4" align="right">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_reward"
                                            @input="translationsChanged"
                                            hint="Project reward">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ rewardPoints }}
                                            </div>
                                        </text-editor>
                                    </v-col>
                                </v-row>

                                <!-- MOBILE COMPATIBLE -->
                                <v-row dense>
                                    <v-col cols="8" align="left">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_mobile_text"
                                            @input="translationsChanged"
                                            hint="Mobile compatible text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ translations.project_info_mobile_text }}
                                            </div>
                                        </text-editor>
                                    </v-col>

                                    <v-col cols="4" align="right">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_incompatible_text"
                                            @input="translationsChanged"
                                            hint="Incompatible text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ mobileCompatible }}
                                            </div>
                                        </text-editor>
                                    </v-col>
                                </v-row>

                                <!-- TABLE COMPATIBLE -->
                                <v-row dense>
                                    <v-col cols="8" align="left">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_tablet_text"
                                            @input="translationsChanged"
                                            hint="Tablet compatible text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ translations.project_info_tablet_text }}
                                            </div>
                                        </text-editor>
                                    </v-col>

                                    <v-col cols="4" align="right">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_compatible_text"
                                            @input="translationsChanged"
                                            hint="Compatible text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ tabletCompatible }}
                                            </div>
                                        </text-editor>
                                    </v-col>
                                </v-row>

                                <!-- DESKTOP COMPATIBLE -->
                                <v-row dense>
                                    <v-col cols="8" align="left">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_desktop_text"
                                            @input="translationsChanged"
                                            hint="Desktop compatible text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ translations.project_info_desktop_text }}
                                            </div>
                                        </text-editor>
                                    </v-col>

                                    <v-col cols="4" align="right">
                                        <text-editor
                                            :editable="editable"
                                            v-model="translations.project_info_compatible_text"
                                            @input="translationsChanged"
                                            hint="Compatible text">
                                            <div :class="getFontClasses(settings.surveyBoxColor)">
                                                {{ desktopCompatible }}
                                            </div>
                                        </text-editor>
                                    </v-col>
                                </v-row>

                            </v-container>

                            <json v-if="debug" :data="componentData"></json>
                        </v-card-text>

                    </v-card>
                </v-card>
            </template>
            Project information box can be edited in the Sub Panel Landing Page Templates.
        </v-tooltip>
    </v-scale-transition>
</template>

<script>

import TextEditor from "../TextEditor";
import Json from 'vue-json-pretty';
import colorMixin from "../DynamicProflingQuestions/colorMixin";

export default {

    mixins: [colorMixin],

    components: {
        TextEditor,
        Json,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        visible: {
            type: Boolean,
            required: false,
            default: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: true,
        },
        settings: {
            type: Object,
            required: true,
        },
        componentData: {
            type: Object,
            required: true,
            default: () => {
                return {
                    reward_completed: null,
                    loi: null,
                    mobile_friendly: null,
                    tablet_friendly: null,
                    desktop_friendly: null,
                }
            }
        },
        displayEditInfo: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    computed: {
        duration() {
            if (this.translations.project_info_duration) {
                return this.translations.project_info_duration.replace('[duration]', this.componentData.loi);
            }
        },
        rewardPoints() {
            if (this.translations.project_info_reward) {
                return this.translations.project_info_reward.replace('[reward-points]', this.componentData.reward_completed);
            }
        },
        mobileCompatible() {
            return this.componentData.mobile_friendly ?
                this.translations.project_info_compatible_text :
                this.translations.project_info_incompatible_text;
        },
        tabletCompatible() {
            return this.componentData.tablet_friendly ?
                this.translations.project_info_compatible_text :
                this.translations.project_info_incompatible_text;
        },
        desktopCompatible() {
            return this.componentData.desktop_friendly ?
                this.translations.project_info_compatible_text :
                this.translations.project_info_incompatible_text;
        },

    },

    data() {
        return {
            debug: false,
            translations: {
                project_info_text: null,
                project_info_duration_text: null,
                project_info_duration: null,
                project_info_reward_text: null,
                project_info_reward: null,
                project_info_compatible_text: null,
                project_info_incompatible_text: null,
                project_info_mobile_text: null,
                project_info_tablet_text: null,
                project_info_desktop_text: null,
            },
        }
    },

    mounted() {
        this.translations = Object.assign({}, this.value);
    },

    watch: {
        value(translations) {
            this.translations = Object.assign({}, translations);
        },
    },

    methods: {
        translationsChanged() {
            this.$emit('change', this.value);
        }
    }
}
</script>
